import {
  DateTime,
} from 'luxon';

import type {
  Subscription
} from '@gymcloud/core';

import {
  Button,
} from 'web-components';
import {
  Flex,
  Text,
} from 'web-styled';

import * as S from '../styled';

const getNextText = (subscription?: Subscription) => {
  let text = subscription?.cancel_at_period_end ? 'Subscribed Until' : 'Next Payment Date';
  if (subscription?.status === 'past_due') { text = 'Next Payment Attempt'; }
  return text;
};

type Props = {
  subscription?: Subscription,
  lastFailedInvoice: boolean,
  paymentAttempt: { (): void },
}

const SubscriptionNextPaymentInfo = ({
  subscription,
  paymentAttempt,
  lastFailedInvoice,
}: Props) => {
  return (
    <Flex width="100%" column>
      <S.SectionCaption>
        {getNextText(subscription)}
      </S.SectionCaption>
      <Flex
        flex="0 0 calc(22% - 32px)"
        width="100%"
        column
        justify="center"
        align="center"
        spacing={15}
        minHeight="160px"
      >
        {subscription?.current_period_end ? (
          <Text
            size="22px"
            weight="600"
            color="303032"
          >
            {DateTime.fromMillis(subscription.current_period_end * 1000).toFormat('MMMM dd, yyyy')}
          </Text>
        ) : (
          <Text
            size="18px"
            color="#CCCCCC"
          >
            You have no active subscriptions
          </Text>
        )}

        {lastFailedInvoice && (
          <Button
            appearance="primary"
            onClick={paymentAttempt}
          >
            Make Payment Attempt
          </Button>
        )}
      </Flex>
    </Flex>
  )
}

export default SubscriptionNextPaymentInfo;
